export const USE_NEEDS_ACTION_PAGE_FLAG = 'needs-action-page';

export const USE_TRIP_MAP_LOCATION_FILTERS_FLAG =
  'use-trip-map-location-filters';

export const USE_OMNI_INSIGHTS_FLAG = 'use-omni-insights';

export const USE_OMNI_REPORT_BUILDER_FLAG = 'use-omni-report-builder';

export const USE_OMNI_QUERIER_FLAG = 'use-omni-querier';

export const USE_KINETIK_AI_CALL_CENTER_EXTERNAL_ORIGIN_FLAG =
  'use-kinetik-ai-call-center-external-origin';

export const USE_PROVIDER_PROFILE_CREDENTIALING_TAB_FLAG =
  'use-provider-profile-credentialing-tab';

export const USE_PROVIDER_PROFILE_DRIVERS_TAB_FLAG =
  'use-provider-profile-drivers-tab';

export const USE_PROVIDER_PROFILE_VEHICLES_TAB_FLAG =
  'use-provider-profile-vehicles-tab';

// Kill switch: turning it on in LD hides the Provider Profile Insights data
// without a deploy. Off by default, so Insights works unless it is switched on.
export const DISABLE_PROVIDER_INSIGHTS_FLAG = 'disable-provider-insights';
export const USE_CONTRACT_CREATION_V2_FLAG = 'use-contract-creation-v2';
export const USE_EXTERNAL_TRIP_REQUESTS_FLAG = 'use-external-trip-requests';
export const USE_NEEDS_ACTION_CORRECTIONS_TABLE_FLAG =
  'use-needs-action-corrections-table';

export const USE_NOTIFICATION_CONTACT_PREFERENCES_FLAG =
  'notification-contact-preferences-enabled';

// TS-8933 — interim granular trip permissions. Gates BOTH the role-modal
// toggles and the CTA enforcement that reads them. There is no backend
// migration granting the 12 granular keys — the legacy god permission stays
// and the new set layers on top — so this must stay OFF until admins have
// granted the keys in the role modal. Enabling early hides bulk actions from
// roles whose coarse keys don't cover them, e.g. a role holding `cancel` but
// not `write` does not satisfy `bulk_cancel`. (`assign` DOES satisfy
// `bulk_assign` — that pair is symmetric; see COARSE_SATISFIES.)
// Despite the name, this also gates member (`patients`) checks via hasPatient (TS-9474).
export const USE_GRANULAR_TRIP_PERMISSIONS_FLAG = 'granular-trip-permissions';

// Flag for enabling denial letter generation for PHC.
export const USE_PHC_LETTER_GENERATION_FLAG = 'use-phc-letter-generation';

// Flag key read only in App's ldClient.identify() callback (raw client, not
// the React context), listed here so the inventory below stays complete.
export const USE_INTERCOM_FLAG = 'intercom';

/**
 * Every LaunchDarkly flag the frontend reads, with its in-code default.
 *
 * Passed as the `flags` option to asyncWithLDProvider (LaunchDarklyProvider),
 * which scopes the React flag context to exactly these keys:
 * - useFlags() consumers only re-render when one of THESE flags changes
 * - a registered flag is never `undefined` — the default below is returned
 *   until LD delivers a real value. (Exception: LaunchDarklyProvider's
 *   PassthroughProvider fallback bypasses the SDK entirely, so reads are
 *   `undefined` there — equivalent to these defaults while all are false.)
 *
 * IMPORTANT: a flag key missing from this map is invisible to useFlags() in
 * every environment — reads resolve to `undefined` with no error. When adding
 * a flag constant above, register it here in the same change.
 *
 * Defaults are false: features stay hidden until LD affirmatively enables
 * them, matching each flag's off-variation in the LD dashboard.
 */
export const FEATURE_FLAG_DEFAULTS = Object.freeze({
  [DISABLE_PROVIDER_INSIGHTS_FLAG]: false,
  [USE_NEEDS_ACTION_PAGE_FLAG]: false,
  [USE_TRIP_MAP_LOCATION_FILTERS_FLAG]: false,
  [USE_OMNI_INSIGHTS_FLAG]: false,
  [USE_OMNI_REPORT_BUILDER_FLAG]: false,
  [USE_OMNI_QUERIER_FLAG]: false,
  [USE_KINETIK_AI_CALL_CENTER_EXTERNAL_ORIGIN_FLAG]: false,
  [USE_PROVIDER_PROFILE_CREDENTIALING_TAB_FLAG]: false,
  [USE_PROVIDER_PROFILE_DRIVERS_TAB_FLAG]: false,
  [USE_PROVIDER_PROFILE_VEHICLES_TAB_FLAG]: false,
  [USE_CONTRACT_CREATION_V2_FLAG]: false,
  [USE_EXTERNAL_TRIP_REQUESTS_FLAG]: false,
  [USE_NEEDS_ACTION_CORRECTIONS_TABLE_FLAG]: false,
  [USE_NOTIFICATION_CONTACT_PREFERENCES_FLAG]: false,
  [USE_INTERCOM_FLAG]: false,
  [USE_GRANULAR_TRIP_PERMISSIONS_FLAG]: false,
  [USE_PHC_LETTER_GENERATION_FLAG]: false,
});
